import { j as json } from "../../../../chunks/index2.js";
import { s as sendBugReport } from "../../../../chunks/mailer.js";
const POST = async ({ request }) => {
  const { title, description, machine } = await request.json();
  await sendBugReport(title, description, machine);
  return json({ success: true });
};
export {
  POST
};
